import { doesItFit } from "./doesItFit"

export const positions = Object.freeze({
  TOP_RIGHT: "topRight",
  RIGHT_MIDDLE: "rightMiddle",
  BOTTOM_RIGHT: "bottomRight",
  BOTTOM_MIDDLE: "bottomMiddle",
  BOTTOM_LEFT: "bottomLeft",
  LEFT_MIDDLE: "leftMiddle",
  TOP_LEFT: "topLeft",
  TOP_MIDDLE: "topMiddle",
})
export const positionsList = Object.values(positions)
/**
 * Places the tooltip on the dom on the preferable placement
 * @param {string} preferablePlacement  one of the positions values
 * @param {HTMLElement} anchorElement
 * @param {HTMLElement} tooltipElement
 * @param {boolean} autoFit if true it will try other fits
 */
export function placeTooltip(preferablePlacement, anchorElement, tooltipElement, autoFit) {
  if (!anchorElement || !tooltipElement) {
    return
  }
  const rect = anchorElement.getBoundingClientRect()
  tooltipElement.classList.add("is-placing")
  document.querySelector("body").appendChild(tooltipElement)
  const tooltipRect = tooltipElement.getBoundingClientRect()
  const { width, height, y, x } = rect
  const { width: tooltipWidth, height: tooltipHeight } = tooltipRect
  const topY = y + window.scrollY - tooltipHeight
  const rightX = x + width + window.scrollX
  const leftX = x + window.scrollX - tooltipWidth
  const bottomY = y + height + window.scrollY
  const middleX = x + width / 2 + window.scrollX - tooltipWidth / 2
  const middleY = y + window.scrollY + height / 2 - tooltipHeight / 2

  const positionMap = {
    topRight: {
      top: topY,
      left: rightX,
    },
    bottomRight: {
      top: bottomY,
      left: rightX,
    },
    topLeft: {
      top: topY,
      left: leftX,
    },
    bottomLeft: {
      top: bottomY,
      left: leftX,
    },
    bottomMiddle: {
      top: bottomY,
      left: middleX,
    },
    topMiddle: {
      top: topY,
      left: middleX,
    },
    leftMiddle: {
      top: middleY,
      left: x - tooltipWidth,
    },
    rightMiddle: {
      top: middleY,
      left: x + width,
    },
  }
  let originalPlacementIndex = positionsList.findIndex((value) => value === preferablePlacement)
  if (originalPlacementIndex < 0) {
    originalPlacementIndex = 0

    console.warn(`${preferablePlacement} not found. Please use one of ${Object.keys(positionMap).join(", ")}`)
  }
  const { length: numberOfPositions } = positionsList
  let currentPlacement
  let top = 0
  let left = 0
  // It will loop though all the placements until it fits, if it does not fit will put on the original place anyway
  let index
  for (let i = 0; i <= numberOfPositions; i++) {
    index = (originalPlacementIndex + i) % numberOfPositions
    currentPlacement = positionsList[index]
    const newPositions = positionMap[currentPlacement]
    ;({ top, left } = newPositions)
    if (!autoFit || doesItFit(tooltipRect, top, left)) {
      break
    }
  }
  tooltipElement.style.top = `${top}px`
  tooltipElement.style.left = `${left}px`
  tooltipElement.classList.remove("is-placing")
}
